// Text an agent wrote, with any citations shown as links that open the document.
import { useMemo } from "react";

import { Markdown } from "./Markdown";
import { useCitations } from "./useCitations";

export const Cited = ({
  text,
  inline = false,
}: {
  text: string;
  inline?: boolean;
}) => {
  // A line after a list is its own paragraph, not the last item's continuation.
  const separated = useMemo(
    () =>
      text.replace(
        /(^|\n)((?:\d+\.|[-*]) [^\n]*)\n(?!(?:\d+\.|[-*]) )/g,
        "$1$2\n\n",
      ),
    [text],
  );
  const bodies = useMemo(() => [separated], [separated]);
  const { components, transform, modal } = useCitations(bodies);
  return (
    <>
      <Markdown components={components} inline={inline}>
        {transform(separated)}
      </Markdown>
      {modal}
    </>
  );
};
